import { Injectable, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RoutesRecognized, Event, NavigationEnd } from '@angular/router';
import { Logger } from '@projects/shared/src/app';
import { CacheHouseProvider } from './cache/cachehouse.provider';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication/authentication.service';

const log = new Logger('AnalyticsService');

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  timer = new Date();
  currentURL = '';
  activity: any = {};
  interaction: any = '';
  refreshId = String(new Date().getTime());
  exitDateTime = new Date();
  moduleMapping: { [key: string]: string } = {
    summaries: 'Stats',
    'agent-call-evaluation': 'Quality',
    chat: 'Chat',
    user: 'Users',
    tfn: 'TFN',
    // Add more mappings as needed
  };

  constructor(
    private http: HttpClient,
    private cache: CacheHouseProvider,
    private router: Router,
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute
  ) {
    // this.init();
    // window.addEventListener('f_click', (e: any) => {
    //   console.log(new Date().toLocaleString() + '  ➤  f_click e ==> ', e);
    //   this.cache.setItem(String(Date.now()), {
    //     id: String(new Date().getTime()),
    //     A_ID: String(new Date().getTime()),
    //     User_ID: this.authService.getUserId(),
    //     URL: this.currentURL,
    //     EventType: 'click',
    //     RefreshId: this.refreshId,
    //     Page: this.getPageFromUrl(document.location.pathname),
    //     Module: this.getModuleNameFromUrl(document.location.pathname),
    //     Role: this.authService.authData.Role,
    //     When: new Date(),
    //     ...e.detail
    //     //Metadata: e.detail,
    //   });
    // });
    // window.addEventListener('locationchange', (e: any) => {
    //   this.cache.setItem(String(Date.now()), {
    //     id: String(new Date().getTime()),
    //     A_ID: String(new Date().getTime()),
    //     User_ID: this.authService.getUserId(),
    //     URL: this.currentURL,
    //     EventType: 'locationchange',
    //     Page: this.getPageFromUrl(document.location.pathname),
    //     Module: this.getModuleNameFromUrl(document.location.pathname),
    //     RefreshId: this.refreshId,
    //     Role: this.authService.authData.Role,
    //     When: new Date(),
    //     ...e.detail
    //     //Metadata: e.detail,
    //   });
    // });
    // setTimeout(() => {
    //   this.start();
    // }, 3000);
  }

  hello() {
    log.info('Hello');
  }

  getPageFromUrl(url: string) {
    const urlSegments = url.split('/').filter((segment) => segment);
    let index = urlSegments.length - 1;

    if (urlSegments[index] && urlSegments[index].indexOf('-') > -1) {
      return urlSegments[index].replace('-', ' ');
    } else if (urlSegments[index] && urlSegments[index].indexOf('-') < 0) {
      return `${urlSegments[index - 1]} ${urlSegments[index]}`;
    }
    return '';
  }

  getModuleNameFromUrl(url: string): string {
    if (!url) {
      return '';
    }

    // Split the URL into segments
    const segments = url.split('/').filter((segment) => segment); // filter to remove any empty segments

    if (segments.length === 0) {
      return '';
    }

    // If there are more than 2 segments, return the second last one
    if (segments.length > 2) {
      return this.mapModuleName(segments[segments.length - 2]);
    } else {
      // Otherwise, return the last one
      return this.mapModuleName(segments[segments.length - 1]);
    }
  }

  mapModuleName(moduleName: string): string {
    // const moduleMapping: { [key: string]: string } = {
    //   'summaries': 'Call Summaries Module',
    //   'recordings': 'Recordings Module',
    //   'insight': 'Insight Module',
    //   'admin': 'Admin Module',
    //   // Add more mappings as needed
    // };

    // Return the mapped module name or a default value if not found
    return this.moduleMapping[moduleName] || moduleName;
  }

  formatTime(ms: any) {
    return Math.floor(ms / 1000);
  }

  cloneDeep(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  recordEventInfo(eventName: string, event: any) {
    if (!this.activity[eventName]) {
      this.activity[eventName] = {};
    }
    this.activity[eventName][event.target.nodeName] = this.activity[eventName][event.target.nodeName]
      ? this.activity[eventName][event.target.nodeName] + 1
      : 1;

    const interaction = (event.target.getAttribute && event.target.getAttribute('data-interaction')) || '';
    console.log(new Date().toLocaleString() + '  ➤  interaction 1 ==> ', interaction);
    if (!this.interaction[eventName]) {
      this.interaction = { [eventName]: {} };
    }
    if (interaction && !this.interaction[eventName][interaction]) {
      this.interaction[eventName][interaction] = 0;
    }

    if (interaction) {
      this.interaction[eventName][interaction] = this.interaction[eventName][interaction]
        ? this.interaction[eventName][interaction] + 1
        : 1;
    }

    if (eventName === 'click') {
      console.log(new Date().toLocaleString() + '  ➤  interaction click ==> ', interaction);
      console.log(new Date().toLocaleString() + '  ➤  interaction  event ==> ', event);
      window.dispatchEvent(
        new CustomEvent('f_click', {
          detail: {
            //ClientX: event.clientX,
            //ClientY: event.clientY,
            //WindowWidth: window.innerWidth,
            //WindowHeight: window.innerHeight,
            //ClassName: event.target.className,
            //EId: event.target.id,
            Element: event.target.nodeName,
            Interaction: interaction,
          },
        })
      );
    }

    if (eventName === 'beforeunload') {
      if (this.authService.isLoggedIn) {
        // Cancel the event as stated by the standard.
        //event.preventDefault();
        // Chrome requires returnValue to be set.
        //event.returnValue = '';
        const module = this.getModuleNameFromUrl(document.location.pathname);
        const page = this.getPageFromUrl(document.location.pathname);

        this.cache.setItem(String(Date.now()), {
          id: String(new Date().getTime()),
          A_ID: String(new Date().getTime()),
          User_ID: this.authService.getUserId(),
          URL: this.currentURL,
          EventType: 'beforeunload',
          Page: page || 'misc',
          Module: module || 'misc',
          RefreshId: this.refreshId,
          Role: this.authService.authData.Role,
          When: new Date(),
          //Metadata: {},
        });

        this.start();
        //return undefined;
      }
    }
  }

  init() {
    // ['popstate', 'click', 'keydown', 'keyup', 'touchstart', 'touchend', 'beforeunload', 'unload'].forEach(
    //   (eventName) => {
    //     window.addEventListener(eventName, (event) => {
    //       if (eventName === 'beforeunload') {
    //         this.recordEventInfo(eventName, event);
    //       } else {
    //         setTimeout(() => {
    //           this.recordEventInfo(eventName, event);
    //           const currentHref = location.href;
    //           const lastURL = this.currentURL;
    //           if (currentHref !== lastURL) {
    //             this.currentURL = currentHref;
    //             const enterDateTime = this.timer;
    //             const timeSpent = new Date().getTime() - this.timer.getTime();
    //             window.dispatchEvent(
    //               new CustomEvent('locationchange', {
    //                 detail: {
    //                   EnterDateTime: enterDateTime,
    //                   ExitDateTime: new Date(),
    //                   Duration: timeSpent / 1000,
    //                   From: lastURL,
    //                   Interaction: '',
    //                   //Activity: this.cloneDeep(this.activity),
    //                   To: this.currentURL,
    //                 },
    //               })
    //             );
    //             this.timer = new Date();
    //             this.activity = {};
    //             this.interaction = {};
    //           }
    //         }, 0);
    //       }
    //     });
    //   }
    // );
  }

  store() {
    // if (this.authService.isLoggedIn) {
    //   this.cache.getAll().then((records) => {
    //     if (records.length > 0) {
    //       console.log(new Date().toLocaleString() + '  ➤  records ==> ', records);
    //       this.http
    //         .disableLoader()
    //         .post('/analytics', { Info: records })
    //         .subscribe((response) => {
    //           records.forEach((record: any) => {
    //             this.cache.removeItem(record.id);
    //           });
    //         });
    //     }
    //   });
    // }
  }

  start() {
    // this.store();
    // setInterval(() => {
    //   this.store();
    // }, 10000); // 3 minutes
  }
}
